
import { faAngleDown, faChevronRight, faFile, faInfoCircle, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';

export interface FilterMenu {
  label: string;
  items: FilterMenuItem[];
}

export interface FilterMenuItem {
  label: string;
  value?: string;
  onClick?: () => void;
  children?: FilterMenuItem[];
}

interface InventoryHistoryFilterGroupProps {
  menus: FilterMenu[];
}

const RecursiveDropdown = ({ items }: { items: FilterMenuItem[] }) => {
  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.children && item.children.length > 0 ? (
            <Dropdown drop="end" className="w-100">
              <Dropdown.Toggle as="div" className="dropdown-item d-flex justify-content-between align-items-center w-100">
                <span onClick={item.onClick}>{item.label}</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ zIndex: 9999 }}>
                <RecursiveDropdown items={item.children} />
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Dropdown.Item 
              onClick={item.onClick} 
              className="d-flex align-items-center py-2"
            >
              {item.label === "Draft" && (
                <FontAwesomeIcon icon={faFile} className="me-2 text-secondary" />
              )}
              {item.label === "Assigned" && (
                <FontAwesomeIcon icon={faInfoCircle} className="me-2 text-primary" />
              )}
              {item.label === "Done" && (
                <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
              )}
              {item.label === "All" && (
                <FontAwesomeIcon icon={faAngleDown} className="me-2 text-primary" />
              )}
              {item.label === "Cancelled" && (
                <FontAwesomeIcon icon={faTimesCircle} className="me-2 text-danger" />
              )}
              <span>{item.label}</span>
            </Dropdown.Item>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

const InventoryHistoryFilterGroup = ({ menus }: InventoryHistoryFilterGroupProps) => {
  return (
    <div style={{ width: '100%' }}>
      <ButtonGroup style={{ width: '100%' }}>
        {menus.map((menu, menuIndex) => (
          <Dropdown key={menuIndex} as={ButtonGroup}>
            <Dropdown.Toggle
              variant="phoenix-secondary"
              className="px-7 flex-shrink-0 dropdown-caret-none text-truncate"
              style={{ maxWidth: '100%', overflow: 'hidden' }}
            >
              {menu.label}
              <FontAwesomeIcon icon={faAngleDown} className="ms-2" transform="down-2" />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ zIndex: 9999, padding: '0.5rem 0', minWidth: '15rem' }}>
              <RecursiveDropdown items={menu.items} />
            </Dropdown.Menu>
          </Dropdown>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default InventoryHistoryFilterGroup;
